<template>
  <div class="items img-box" :name="selectData.elementCode" :data-path="selectData.elementPath">
    <div class="items-wrap">
      <span class="lables">{{selectData.elementName}}</span>
      <div class="from-right">
        <van-uploader :after-read="update" :before-delete="delite" v-model="fileList" :max-count="max" />
      </div>
    </div>
    <div class="verify-box" v-if="verify">
        <p class="verify-title">证件识别结果：</p>
        <div class="verify-li" v-for="item in verify">
          {{item.elementName}}：{{item.elementValue}}
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      selectData: {
        type: Object,
      },
    },
    data() {
      return {
        fileList: [], //图片上传
        max:1,
        params:null,
        verify:null,//证件识别结果
      };
    },
    computed: {},
    mounted() {
      this.params=this.selectData.elementParams || null;
      if(this.selectData.elementValue){
        this.fileList=this.selectData.elementValue;
      }
      if(this.selectData.elementValue && this.selectData.elementValue[0].params){
        this.verify=this.selectData.elementValue[0].params;
      }
    },
    methods: {
      /**
       * 上传图片
       */
      update(file) {
        console.log(file);
        let length=this.fileList.length-1;
        file.status = 'uploading';
        file.message = '上传中...';
        let param = new FormData(); //创建form对象
        param.append('file', file.file); //通过append向form对象添加数据
        if(this.params){
          param.append('params',this.params); //相关参数
        }
        this.$http({
          url: "/insure/ocr",
          data: param,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(data => {
          console.log(data)
          file.url=data.data.wwwurl;
          file.params=data.data.verify;
          this.verify=data.data.verify;
          file.status = 'done';
          file.message = '';
          this.getResult()
        }).catch(err=>{
          file.status = 'failed';
          file.message = '上传失败';
        })
      },
      // 删除图片
      delite(e,d) {
        this.fileList.splice(d.index, 1);
        this.verify=null;
        this.getResult()
      },
      getResult() {
        let value = [];
        this.fileList.forEach(item=>{
          value.push({
            url:item.url,
            params:item.params || "",
          })
        })
        if(this.fileList.length==0)value=null;
        console.log(value);
        this.selectData.elementValue=value;
        this.$emit("selected", {
          type:1,
          item:this.selectData,
          value: value
        });
      },
    },
    watch: {
      files(newVal) {
        if (newVal.length == 0) {
          this.fileList = [];
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .van-uploader{
    padding-top: 15px;
  }
  .verify-box{
    padding-left: 230px;
    padding-bottom: 5px;
    .verify-title{
      font-size: 30px;
      color: #333;
    }
    .verify-li{
      font-size: 28px;
      color: #666;
      line-height: 1.4;
      padding: 3px 0;
      border-bottom: 1px dashed #ececec;
      word-break: break-all;
    }
  }
  .img-box{
    .lables{
      width: 40%;
    }
    .from-right{
      width: 58%;
    }
  }
</style>